import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import Button from "./button";
import Text from "./text";
import Flex from "./flex";

const Counter = ({
  value = 0,
  onAdd = () => {},
  onRemove = () => {},
  disabled = { left: false, right: false },
  button = {},
  className = "",
}) => {
  return (
    <Flex align="center" gap={"1.5rem"} className={className}>
      <Button
        onClick={onRemove}
        disabled={disabled?.left}
        icon={<MinusOutlined />}
        {...button}
      />
      <Text weight={600} children={value} />
      <Button
        onClick={onAdd}
        icon={<PlusOutlined />}
        disabled={disabled?.right}
        {...button}
      />
    </Flex>
  );
};

export default Counter;
